import { useQueryClient } from "@tanstack/react-query";
import { TEAM_COACHES_QUERY_KEY } from "./CoachTeamRoute";
import { COACH_CLIENTS_LIST_QUERY_KEY } from "../../../components/coach-clients/CoachClientsListScreen";
import {
  MESSAGES_THREAD_QUERY_KEY,
  MESSAGES_THREADS_QUERY_KEY,
} from "../../../components/screen/MessagingScreen";
import { EXISTING_MEMBERS_QUERY_KEY } from "../../../components/groups/ManageGroupHierarchyDialog";
import { TRANSFER_CLIENTS_DIALOG_QUERY_KEY } from "../../../components/coach-clients/TransferClientsDialog";
import { COACH_MESSAGE_RECIPIENTS_QUERY_KEY } from "../../../components/messages/RecipientDialog";
import { MANAGE_PROGRAM_CLIENTS_DIALOG_QUERY_KEY } from "../../../components/groups/ClientsAndGroupsSelectDialog";
import { CURRENT_USER_QUERY_KEY } from "../../../wrappers/current-user/CurrentUserWrapper";
import { COACH_PROGRAMS_LIST_QUERY_KEY } from "../../../components/coach-programs/CoachProgramsListScreen";
import {
  COACH_GROUPS_LIST_QUERY_KEY,
  COACH_GROUPS_COUNT_QUERY_KEY,
} from "../../../routes/coach/groups/CoachGroupsListRoute";
import { ACTIVITY_LIST_QUERY_KEY } from "../../../components/activity/CoachActivity";
import { CLIENT_ENROLLMENTS_FOR_CALENDAR_QUERY_KEY } from "../../../routes/coach/client/calendar/CoachClientCalendarRoute";

export const useInvalidateTeamQueries = () => {
  const queryClient = useQueryClient();

  return () => {
    const keysToInvalidate = [
      TEAM_COACHES_QUERY_KEY,
      MESSAGES_THREAD_QUERY_KEY,
      MESSAGES_THREADS_QUERY_KEY,
      COACH_CLIENTS_LIST_QUERY_KEY,
      EXISTING_MEMBERS_QUERY_KEY,
      TRANSFER_CLIENTS_DIALOG_QUERY_KEY,
      COACH_MESSAGE_RECIPIENTS_QUERY_KEY,
      MANAGE_PROGRAM_CLIENTS_DIALOG_QUERY_KEY,
      COACH_PROGRAMS_LIST_QUERY_KEY,
      COACH_GROUPS_LIST_QUERY_KEY,
      COACH_GROUPS_COUNT_QUERY_KEY,
      ACTIVITY_LIST_QUERY_KEY,
      CLIENT_ENROLLMENTS_FOR_CALENDAR_QUERY_KEY,
    ];

    keysToInvalidate.forEach((key) => {
      queryClient.invalidateQueries({ queryKey: [key], exact: false });
    });

    queryClient.invalidateQueries({
      queryKey: [CURRENT_USER_QUERY_KEY],
      refetchType: "all",
    });
  };
};
